import { type FunctionComponent, type PropsWithChildren, useState, createContext } from 'react';
import { useRouteChange } from '../../hooks/routing/route-change.hook';

type ScrollLockContextState = {
	isScrollLocked: boolean;
	setIsScrollLocked: (lockScrolling: boolean) => void;
};

const initialState = {
	isScrollLocked: false,
	setIsScrollLocked: () => {}
};

export const ScrollLockContext = createContext<ScrollLockContextState>(initialState);

export const ScrollLockContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
	const [isScrollLocked, setIsScrollLocked] = useState(false);

	useRouteChange(() => {
		setIsScrollLocked(false);
	});

	const value = {
		isScrollLocked,
		setIsScrollLocked
	};
	return <ScrollLockContext.Provider value={value}>{children}</ScrollLockContext.Provider>;
};
